import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
export const HeroSection = () => {
  const navigate = useNavigate();
  const {
    t
  } = useTranslation();
  return <div className="min-h-screen w-full bg-[radial-gradient(at_75%_26%,#A7DCD8_10%,#8791F3_50%,#F1F6F5_60%)]">
    <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} className="min-h-screen flex flex-col px-4 sm:px-6 lg:px-28">
      {/* Main Hero Content */}
      <div className="flex-1 flex items-center pb-8 pt-20 sm:pt-28 md:pt-40">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full">
          {/* Left Section (Text) - Takes up 2/3 */}
          <div className="md:col-span-2 text-center md:text-left max-w-2xl mx-auto md:mx-0">
            <h1 className="text-3xl sm:text-5xl font-bold tracking-tight text-[#34375B] md:text-7xl mb-4 sm:mb-6 max-w-xl">
              {t("hero.title")}
            </h1>
            <p className="text-base sm:text-lg leading-7 sm:leading-8 text-[#34375B]/85 max-w-lg mb-8 sm:mb-12 font-medium">
              {t("hero.description")}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
              <Button onClick={() => navigate("/signup")} size="lg" className="bg-[#8791F3] hover:bg-[#5CC2BB] hover:text-[#34375B] hover:shadow-[4px_4px_0px_0px_#34375B] hover:-translate-x-1 hover:-translate-y-1 transition-all duration-200 text-white px-8 sm:px-12 py-5 sm:py-6 text-base sm:text-lg rounded-xl w-full sm:w-auto">
                {t("hero.cta")}
              </Button>
              <Button onClick={() => window.open("https://calendly.com/daisycd/15min", "_blank")} size="lg" className="px-8 sm:px-12 py-5 sm:py-6 text-base sm:text-lg text-[#34375B] bg-[#5CC2BB] rounded-xl hover:bg-[#8791F3] hover:text-[#F1F6F5] hover:shadow-[4px_4px_0px_0px_#34375B] hover:-translate-x-1 hover:-translate-y-1 transition-all duration-200 w-full sm:w-auto">
                {t("hero.book_demo")}
              </Button>
            </div>
          </div>

          {/* Right Section (SVG Image) - Takes up 1/3 */}
          <div className="hidden md:flex md:col-span-1 justify-center md:justify-end mt-8 md:mt-0">
            <img src="/landing/undraw_futuristic-interface_sv51.svg" alt="Hero Illustration" className="w-4/5 max-w-md h-auto" />
          </div>
        </div>
      </div>

      {/* Features Introduction */}
      <div className="px-4 py-[5px] pt-[40px] sm:pt-[60px] md:pt-[85px]">
        <div className="mx-auto max-w-2xl text-center mb-10 sm:mb-16">
          <p className="mt-2 text-2xl sm:text-3xl font-bold tracking-tight text-[#34375B] md:text-4xl">
            {t("features.subtitle")}
          </p>
          <p className="mt-4 sm:mt-6 text-base sm:text-lg leading-7 sm:leading-8 text-[#34375B]/70">
            {t("features.description")}
          </p>
        </div>
      </div>
    </motion.div>
  </div>;
};
